import {isLoggedIn} from '../../utils/auth'
import {injectReducer} from '../../store/reducers'
import {categoryAnalyticsReducer} from './modules/CategoryAnalytics'

export default (store) => ({
  path: 'category-analytics',
  onEnter: isLoggedIn(store),
  /*  Async getComponent is only invoked when route matches   */
  getComponent(nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const CategoryAnalytics = require('./containers/CategoryAnalytics').default
      let homeReducers = require('../Home/modules/home');
      const {loadBillFieldsReducer} = require('../SalesForecasts/modules/salesForecasts');
      const {loadStoreOptionsReducer, loadStoreTagOptionsReducer} = require('../SalesAnalytics/modules/salesAnalytics');
      const filterValuesReducer = homeReducers.filterValuesReducer
      injectReducer(store, {key: 'categoryAnalyticsDetails', reducer: categoryAnalyticsReducer})
      injectReducer(store, {key: 'filter', reducer: filterValuesReducer})
      injectReducer(store, {key: 'storeOptions', reducer: loadStoreOptionsReducer})
      injectReducer(store, {key: 'storeTagOptions', reducer: loadStoreTagOptionsReducer})
      injectReducer(store, {key: 'billFields', reducer: loadBillFieldsReducer})

      cb(null, CategoryAnalytics)
      /* Webpack named bundle   */
    }, 'categoryAnalytics')
  }
})



// WEBPACK FOOTER //
// ./src/routes/CategoryAnalytics/index.js